import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";

import { ClassTable, CompleteBaseLineData, CompleteTeachersData, CustomConfirmModal, PupilImport, PupilTable, TeacherTable } from "./";

import "../../assets/stlyes/SchoolAdminTabs.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { setSelect } from "../../store/stylesSlice";

import { NavigationBar, SessionStorageKeys, SUCCESS } from "../../helper"
import { isEmptyObject, SessionStorage } from "../../util";
import { LoadingSpinner, success } from "../Shared";
import * as commonApi from "../../api/commonApi";

import SaveImage from "../../assets/images/Save.png"

const SchoolAdminTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [activeAcademicTabIndex, setActiveAcademicTabIndex] = useState(0)
  const [isTeacherDataTabActive, setIsTeacherDataTabActive] = useState(false)
  const [showAcademicTabs, setShowAcademicTabs] = useState(false)
  const [pupilAcademicDetails, setPupilAcademicDetails] = useState();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [popupSubject, setPopupSubject] = useState("");
  const [confirmByButton, setConfirmByButton] = useState("");
  const dispatch = useDispatch();
  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  
  
  useEffect(() => {
    const savedTab = sessionStorage.getItem("TabIndex");
    setActiveTab(savedTab !== null ? parseInt(savedTab) : 0);
    dispatch(setSelect(NavigationBar.Admin))
    getSchoolDetails()
  }, []);

  const getSchoolDetails = async () => {
    const getSchool = await commonApi.getCurrentSchool();
    !isEmptyObject(getSchool) ?setIsTeacherDataTabActive(getSchool?.Items?.schoolDetailsUpdated):setIsTeacherDataTabActive(false);
  }

  useEffect(() => {
    sessionStorage.setItem("TabIndex", activeTab.toString());
  }, [activeTab]);

  const style = {
    modal_form: {
      marginTop: "70px",
      marginLeft: "20px",

    },
  };

  const handleSelect = (index) => {
    setActiveTab(index);
  }

  const setFullScreen = () => {
    return (!isNavCollapsed ? "170px" : "10px")
  }

  const handleSubmitAcademicDetails = () => {
    setActiveAcademicTabIndex(SessionStorage.getItem(SessionStorageKeys.TabIndex));
    setIsConfirmModalOpen(true);
    setPopupSubject("Are you sure you want to submit? Any academic data you have not provided will be recorded as Unknown.")
    setConfirmByButton("SS");
  }
  const handleCancelAcademicDetails = () => {
    setIsConfirmModalOpen(true);
    setPopupSubject("Are you sure you’d like to cancel? This will terminate the pupil import.")
    setConfirmByButton("C");
  }

  const handleSaveAcademicDetails = () => {
    setIsConfirmModalOpen(true);
    setPopupSubject("Are you sure you want to Save? Any missing data will be recorded as Unknown.")
    setConfirmByButton("S");
  }

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleConfirm = async () => {
    if (confirmByButton === "SS") {
      SessionStorage.setItem(SessionStorageKeys.SavePupilAcademicDetails, JSON.stringify(pupilAcademicDetails));
      setIsConfirmModalOpen(false);
      setIsTeacherDataTabActive(true)
      SessionStorage.setItem(SessionStorageKeys.IsTeacherDataActive, true)
      if (Number(activeAcademicTabIndex) === 1) {
        setIsLoading(true);
        const pupilResponse = await commonApi.pupilBulkUpdate(pupilAcademicDetails);
        if (!isEmptyObject(pupilResponse)) {
          SessionStorage.setItem(SessionStorageKeys.TabIndex, 0);
          SessionStorage.removeItem(SessionStorageKeys.IsTeacherDataActive);
          SessionStorage.removeItem(SessionStorageKeys.SchoolDetailsUpdated);
          SessionStorage.removeItem(SessionStorageKeys.SavePupilAcademicDetails);
          SessionStorage.removeItem(SessionStorageKeys.IsBackground);
          setIsConfirmModalOpen(false);
          success(Number(activeAcademicTabIndex) === 0 ? SUCCESS.BASELINE_DATA_SUBMITTED : SUCCESS.TEACHER_DATA_SUBMITTED)
          success(SUCCESS.PUPIL_ACADEMICDETAILS_UPDATED)
          setShowAcademicTabs(false);
          setIsLoading(false);
        }
      } else {
        setIsLoading(true);
        const pupilResponse = await commonApi.pupilBulkUpdate(pupilAcademicDetails);
        if (!isEmptyObject(pupilResponse)) {
          SessionStorage.setItem(SessionStorageKeys.TabIndex, 1);
          SessionStorage.removeItem(SessionStorageKeys.SavePupilAcademicDetails);
          setIsConfirmModalOpen(false);
          success(Number(activeAcademicTabIndex) === 0 ? SUCCESS.BASELINE_DATA_SUBMITTED : SUCCESS.TEACHER_DATA_SUBMITTED);
          setIsLoading(false);
        }
      }
      handleSelect(1);
    } else if (confirmByButton === "S") {
      SessionStorage.setItem(SessionStorageKeys.SavePupilAcademicDetails, JSON.stringify(pupilAcademicDetails));
      setIsConfirmModalOpen(false);
    } else if (confirmByButton === "C") {
      SessionStorage.removeItem(SessionStorageKeys.IsTeacherDataActive);
      SessionStorage.removeItem(SessionStorageKeys.SavePupilAcademicDetails);
      SessionStorage.removeItem(SessionStorageKeys.IsBackground);
      setIsConfirmModalOpen(false);
      setIsTeacherDataTabActive(false)
      SessionStorage.setItem(SessionStorageKeys.TabIndex, 0);
      success(SUCCESS.PUPIL_IMPORT_CANCELLED);
      setShowAcademicTabs(false);
    }
  };

  return (
    <>
      {isLoading ? <LoadingSpinner /> : (<div>
        {showAcademicTabs ? (
          <div style={style.modal_form}>
            <div className="academic-heading-main" style={{ paddingRight: setFullScreen() }}>
              <div >
                <h1>Academic Details</h1>
                <span>Please note, baseline data can only be provided by School Admin.</span>
              </div>
              <div className="academic-button-main">
                <button onClick={handleSubmitAcademicDetails} className="submit-button-for-academic-details" ><img src={SaveImage} alt="Save & Submit" />Save & Submit</button>
                <button onClick={handleSaveAcademicDetails} className="save-button-for-academic-details" ><img src={SaveImage} alt="Save" /> Save</button>
                <button onClick={handleCancelAcademicDetails} className="cancel-button-for-academic-details">Cancel</button>
              </div>
            </div>
            <Tabs

              selectedIndex={activeTab}
              onSelect={handleSelect}
            >
              <TabList className="schoolAdminTab-academic-tablist">
                <Tab className="schoolAdminTab-academic-tabs">Baseline Data</Tab>
                <Tab className={(!isTeacherDataTabActive )? "schoolAdminTab-academic-tabs-disabled" : "schoolAdminTab-academic-tabs"} disabled={(!isTeacherDataTabActive)}>Teachers Data</Tab>
              </TabList>

              <TabPanel style={{ marginTop: "-16px" }}><CompleteBaseLineData setFullScreen={setFullScreen} setIsTeacherDataTabActive={setIsTeacherDataTabActive} setPupilAcademicDetails={setPupilAcademicDetails} /></TabPanel>
              <TabPanel><CompleteTeachersData setFullScreen={setFullScreen} setIsTeacherDataTabActive={setIsTeacherDataTabActive} setPupilAcademicDetails={setPupilAcademicDetails} /></TabPanel>
            </Tabs>
          </div>
        ) : (
          <Tabs style={style.modal_form} selectedIndex={activeTab} onSelect={(index) => handleSelect(index)}>
            <TabList className="schoolAdminTab-marking-tablist" style={{ marginLeft: "-12px" }}>
              <Tab className="schoolAdminTab-marking-tabs">Pupils</Tab>
              <Tab className="schoolAdminTab-marking-tabs">Classes</Tab>
              <Tab className="schoolAdminTab-marking-tabs">Teachers</Tab>
              <Tab className="schoolAdminTab-marking-tabs">Pupils Import</Tab>
            </TabList>

            <TabPanel>
              <PupilTable setFullScreen={setFullScreen} setShowAcademicTabs={setShowAcademicTabs} />
            </TabPanel>
            <TabPanel>
              <ClassTable setFullScreen={setFullScreen} />
            </TabPanel>
            <TabPanel>
              <TeacherTable setFullScreen={setFullScreen} />
            </TabPanel>
            <TabPanel>
              <PupilImport setFullScreen={setFullScreen} />
            </TabPanel>
          </Tabs>
        )}
        <CustomConfirmModal
          isOpen={isConfirmModalOpen}
          onClose={handleCloseConfirmModal}
          onConfirm={handleConfirm}
          details={popupSubject}
        />

      </div>)}
    </>
  );
}

export { SchoolAdminTabs };
